import { createTheme } from '@mui/material/styles';

const telxiraTheme = createTheme({
  palette: {
    primary: {
      light: '#4fa9c4',
      main: '#007a93',
      dark: '#004e65',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#894494',
      main: '#5a1666',
      dark: '#2e003b',
      contrastText: '#fff',
    },
    type: 'light',
    custom: {
      appBarColor: '#007a93',
    },
  },
});

export default telxiraTheme;
